import { SubAPI } from "./SubAPI";
export class MiscProducts extends SubAPI {
    list(input) { return this.fetcher.get("/api/misc-products", input); }
    upsert(input) { return this.fetcher.post("/api/misc-product", input); }
}
